export const SET_CANDIDATURES_LOADING = "SET_CANDIDATURES_LOADING";
export const SET_CANDIDATURES_ERROR = "SET_CANDIDATURES_ERROR";

export const FETCH_CANDIDATURES_REQUEST = "FETCH_CANDIDATURES_REQUEST";
export const FETCH_CANDIDATURES_SUCCESS = "FETCH_CANDIDATURES_SUCCESS";
export const FETCH_CANDIDATURES_FAIL = "FETCH_CANDIDATURES_FAIL";

export const FETCH_CANDIDATURE_REQUEST = "FETCH_CANDIDATURE_REQUEST";
export const FETCH_CANDIDATURE_SUCCESS = "FETCH_CANDIDATURE_SUCCESS";
export const FETCH_CANDIDATURE_FAIL = "FETCH_CANDIDATURE_FAIL";

export const FETCH_CANDIDATURES_BY_DEMANDE_REQUEST = "FETCH_CANDIDATURES_BY_DEMANDE_REQUEST";
export const FETCH_CANDIDATURES_BY_DEMANDE_SUCCESS = "FETCH_CANDIDATURES_BY_DEMANDE_SUCCESS";
export const FETCH_CANDIDATURES_BY_DEMANDE_FAIL = "FETCH_CANDIDATURES_BY_DEMANDE_FAIL";

export const FETCH_CANDIDATURES_BY_CANDIDAT_REQUEST = "FETCH_CANDIDATURES_BY_CANDIDAT_REQUEST";
export const FETCH_CANDIDATURES_BY_CANDIDAT_SUCCESS = "FETCH_CANDIDATURES_BY_CANDIDAT_SUCCESS";
export const FETCH_CANDIDATURES_BY_CANDIDAT_FAIL = "FETCH_CANDIDATURES_BY_CANDIDAT_FAIL";

export const CREATE_CANDIDATURE_REQUEST = "CREATE_CANDIDATURE_REQUEST";
export const CREATE_CANDIDATURE_SUCCESS = "CREATE_CANDIDATURE_SUCCESS";
export const CREATE_CANDIDATURE_FAIL = "CREATE_CANDIDATURE_FAIL";

export const UPDATE_CANDIDATURE_REQUEST = "UPDATE_CANDIDATURE_REQUEST";
export const UPDATE_CANDIDATURE_SUCCESS = "UPDATE_CANDIDATURE_SUCCESS";
export const UPDATE_CANDIDATURE_FAIL = "UPDATE_CANDIDATURE_FAIL";

export const ANNULER_CANDIDATURE_REQUEST = "ANNULER_CANDIDATURE_REQUEST";
export const ANNULER_CANDIDATURE_SUCCESS = "ANNULER_CANDIDATURE_SUCCESS";
export const ANNULER_CANDIDATURE_FAIL = "ANNULER_CANDIDATURE_FAIL";

export const REJETER_CANDIDATURE_REQUEST = "REJETER_CANDIDATURE_REQUEST";
export const REJETER_CANDIDATURE_SUCCESS = "REJETER_CANDIDATURE_SUCCESS";
export const REJETER_CANDIDATURE_FAIL = "REJETER_CANDIDATURE_FAIL";

export const VALIDER_CANDIDATURE_REQUEST = "VALIDER_CANDIDATURE_REQUEST";
export const VALIDER_CANDIDATURE_SUCCESS = "VALIDER_CANDIDATURE_SUCCESS";
export const VALIDER_CANDIDATURE_FAIL = "VALIDER_CANDIDATURE_FAIL";

export const DELETE_CANDIDATURE_REQUEST = "DELETE_CANDIDATURE_REQUEST";
export const DELETE_CANDIDATURE_SUCCESS = "DELETE_CANDIDATURE_SUCCESS";
export const DELETE_CANDIDATURE_FAIL = "DELETE_CANDIDATURE_FAIL";

export const setCandidaturesLoading = (v) => ({
    type: SET_CANDIDATURES_LOADING,
    payload: v,
});

export const setCandidaturesError = (msg) => ({
    type: SET_CANDIDATURES_ERROR,
    payload: msg,
});

export const fetchCandidaturesRequest = () => ({
    type: FETCH_CANDIDATURES_REQUEST,
});

export const fetchCandidaturesSuccess = (data) => ({
    type: FETCH_CANDIDATURES_SUCCESS,
    payload: data,
});

export const fetchCandidaturesFail = (err) => ({
    type: FETCH_CANDIDATURES_FAIL,
    payload: err,
});

export const fetchCandidatureRequest = (id) => ({
    type: FETCH_CANDIDATURE_REQUEST,
    payload: { id },
});

export const fetchCandidatureSuccess = (data) => ({
    type: FETCH_CANDIDATURE_SUCCESS,
    payload: data,
});

export const fetchCandidatureFail = (err) => ({
    type: FETCH_CANDIDATURE_FAIL,
    payload: err,
});

export const fetchCandidaturesByDemandeRequest = (demandeId) => ({
    type: FETCH_CANDIDATURES_BY_DEMANDE_REQUEST,
    payload: { demandeId },
});

export const fetchCandidaturesByDemandeSuccess = (data) => ({
    type: FETCH_CANDIDATURES_BY_DEMANDE_SUCCESS,
    payload: data,
});

export const fetchCandidaturesByDemandeFail = (err) => ({
    type: FETCH_CANDIDATURES_BY_DEMANDE_FAIL,
    payload: err,
});

export const fetchCandidaturesByCandidatRequest = (candidatId) => ({
    type: FETCH_CANDIDATURES_BY_CANDIDAT_REQUEST,
    payload: { candidatId },
});

export const fetchCandidaturesByCandidatSuccess = (data) => ({
    type: FETCH_CANDIDATURES_BY_CANDIDAT_SUCCESS,
    payload: data,
});

export const fetchCandidaturesByCandidatFail = (err) => ({
    type: FETCH_CANDIDATURES_BY_CANDIDAT_FAIL,
    payload: err,
});

export const createCandidatureRequest = (payload) => ({
    type: CREATE_CANDIDATURE_REQUEST,
    payload,
});

export const createCandidatureSuccess = (data) => ({
    type: CREATE_CANDIDATURE_SUCCESS,
    payload: data,
});

export const createCandidatureFail = (err) => ({
    type: CREATE_CANDIDATURE_FAIL,
    payload: err,
});

export const updateCandidatureRequest = (id, payload) => ({
    type: UPDATE_CANDIDATURE_REQUEST,
    payload: { id, payload },
});

export const updateCandidatureSuccess = (data) => ({
    type: UPDATE_CANDIDATURE_SUCCESS,
    payload: data,
});

export const updateCandidatureFail = (err) => ({
    type: UPDATE_CANDIDATURE_FAIL,
    payload: err,
});

export const annulerCandidatureRequest = (id, motif) => ({
    type: ANNULER_CANDIDATURE_REQUEST,
    payload: { id, motif },
});

export const annulerCandidatureSuccess = (data) => ({
    type: ANNULER_CANDIDATURE_SUCCESS,
    payload: data,
});

export const annulerCandidatureFail = (err) => ({
    type: ANNULER_CANDIDATURE_FAIL,
    payload: err,
});

export const rejeterCandidatureRequest = (id, motif) => ({
    type: REJETER_CANDIDATURE_REQUEST,
    payload: { id, motif },
});

export const rejeterCandidatureSuccess = (data) => ({
    type: REJETER_CANDIDATURE_SUCCESS,
    payload: data,
});

export const rejeterCandidatureFail = (err) => ({
    type: REJETER_CANDIDATURE_FAIL,
    payload: err,
});

export const validerCandidatureRequest = (id) => ({
    type: VALIDER_CANDIDATURE_REQUEST,
    payload: { id },
});

export const validerCandidatureSuccess = (data) => ({
    type: VALIDER_CANDIDATURE_SUCCESS,
    payload: data,
});

export const validerCandidatureFail = (err) => ({
    type: VALIDER_CANDIDATURE_FAIL,
    payload: err,
});

export const deleteCandidatureRequest = (id) => ({
    type: DELETE_CANDIDATURE_REQUEST,
    payload: { id },
});

export const deleteCandidatureSuccess = (id) => ({
    type: DELETE_CANDIDATURE_SUCCESS,
    payload: id,
});

export const deleteCandidatureFail = (err) => ({
    type: DELETE_CANDIDATURE_FAIL,
    payload: err,
});